import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-unified',
    templateUrl: './unified.component.html',
    styleUrls: ['./unified.component.scss'],
    standalone: false
})
export class UnifiedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
